import React from 'react';
import { CheckCircle, AlertTriangle, XCircle, Info, X } from 'lucide-react';

const icons = {
    success: <CheckCircle className="w-6 h-6 text-emerald-500" />,
    error: <XCircle className="w-6 h-6 text-red-500" />,
    warning: <AlertTriangle className="w-6 h-6 text-amber-500" />,
    info: <Info className="w-6 h-6 text-blue-500" />,
};

const bgColors = {
    success: "bg-emerald-500/10",
    error: "bg-red-500/10",
    warning: "bg-amber-500/10",
    info: "bg-blue-500/10",
};

const ModernToast = ({ title, message, type = "info", closeToast }) => {
    return (
        <div className="flex w-full items-start gap-4 p-4 relative">
            <div className={`p-2 rounded-full ${bgColors[type] || bgColors.info} flex-shrink-0 mt-0.5`}>
                {icons[type] || icons.info}
            </div>
            <div className="flex-1 pt-0.5 pr-6">
                <h4 className="font-semibold text-white leading-none mb-1.5 text-[15px]">{title}</h4>
                <p className="text-sm text-gray-400 leading-snug">{message}</p>
            </div>
            <button
                onClick={closeToast}
                className="absolute top-3 right-3 text-gray-500 hover:text-white bg-transparent hover:bg-gray-800 rounded-lg p-1 transition-all"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
};

export default ModernToast;
